module.exports = __webpack_public_path__ + "img/cave177.5237b644.jpg";